import React from 'react';
import PropTypes from 'prop-types';

import DogPlaceholderSvg from 'dpl/common/components/DogPlaceholderSvg';
import SmartImage from 'dpl/components/SmartImage';
import UserAvatar from 'dpl/path_to_payment/components/UserAvatar';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import { SECTION_CLASSES } from 'dpl/quiz/sections/components/Section';

import useContactContext from '../../hooks/useContactContext';

export default function BuyerProfileIntro({
  onStartClick,
  onNextClick,
  canAdvance,
  title,
  subtitle,
  breederProfile,
  dog
}) {
  const { handleLoginClick } = useContactContext();
  const currentUser = useCurrentUser();

  async function handleStartClick() {
    await onStartClick();
    onNextClick();
  }

  const { profile_photo_url: puppyProfilePhotoUrl } = dog;

  return (
    <div className={SECTION_CLASSES}>
      <div className="FullPageQuizQuestion tc">
        <div className="mb8 flex justify-center">
          <UserAvatar
            size="lg"
            user={{ ...breederProfile, id: breederProfile.user_id }}
          />
          {puppyProfilePhotoUrl ? (
            <SmartImage
              Tag="div"
              width="64px"
              height="64px"
              lazy
              className="OverlappingImage bg-center cover h-100 w-100 br-100"
              loadingClass="bg-light-gray br-100"
              src={puppyProfilePhotoUrl}
            />
          ) : (
            <DogPlaceholderSvg
              width="64px"
              height="64px"
              puppy
              className="OverlappingImage bg-light-gray br-100"
            />
          )}
        </div>
        <h3 className="f4 f6-md lh-title mb4">{title}</h3>
        <p className="secondary font-16-mobile mb14">{subtitle}</p>
        <button
          type="button"
          data-test-id="start-buyer-application-button"
          onClick={handleStartClick}
          className="pv3 mt3 mb2 inline-flex fw-medium w-100 justify-center bg-blue-500 white b--blue-500 br2 ph4 font-16"
          disabled={!canAdvance}
        >
          Continue
        </button>
        {!currentUser.isLoggedIn && (
          <p className="secondary tc f2 nt3 mt-1">
            Already have an account?{' '}
            <button
              className="stone-700 link--primary"
              onClick={handleLoginClick}
              type="button"
            >
              Log in
            </button>{' '}
          </p>
        )}
      </div>
    </div>
  );
}

BuyerProfileIntro.propTypes = {
  onStartClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  canAdvance: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  breederProfile: PropTypes.shape({
    user_id: PropTypes.number,
    initials: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired,
  dog: PropTypes.shape({
    profile_photo_url: PropTypes.string
  }).isRequired
};
